module.exports = __webpack_public_path__ + "img/android-install-step-1.732df3bb.svg";